export default __webpack_public_path__ + "static/media/battery-empty-solid.1d2a5373.svg";